import { FC } from "react";

import {
  EditGridColumnButton,
  PanelTopRightWrapperStyled,
  PanelTopStatRides,
} from "@ryde/layout";
import { useIsMobile } from "@ryde/shared";

import { ViewSwitchRides } from "./view-switch.rides";

export const PanelTopRightRides: FC = () => {
  const { isMobile } = useIsMobile();
  return (
    <PanelTopRightWrapperStyled>
      {!isMobile && <PanelTopStatRides />}
      <ViewSwitchRides />
      {!isMobile && <EditGridColumnButton />}
    </PanelTopRightWrapperStyled>
  );
};
